import { checkSitepresence, getStation, getUserID, makeSitepresence } from '@/utils/requestHandler'

import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import SiteprecenseSummary from './SitePresenceSummary/SitepresenceSummary.vue'
import Notification from '@/components/Notification/Notification.vue'
import browser from 'browser-detect'

export default {
   name: 'CreateSitepresence',
   components: {
      BadRequest,
      Notification,
      SiteprecenseSummary
   },
   data() {
      return {
         description: '',
         descriptionValid: null,
         checkedActivities: false,
         activityResponse: null,
         selectedActivity: '',
         activity: '',
         activities: [],
         datePicker: {
            altFormat: 'd.m.Y',
            minDate: 'today',
            locale: this.$i18n.locale
         },
         todaysDate: null,
         endTime: '',
         timeValid: null,
         endDate: '',
         userResponse: null,
         user: '',
         locationResponse: null,
         location: '',
         requestProcessing: false,
         error: null,
         summary: false
      }
   },
   created() {
      this.datePicker = JSON.stringify(this.datePicker)
      this.getActivities()
      this.getSitepresenceStation()
      this.getSitepresenceUserID()
      this.createDate()
      this.detectBrowser()
   },
   methods: {

      detectBrowser() {
         const result = browser()
         if (result.name === 'safari' || result.os.toLowerCase().includes('os')) {
            console.log('This is a safari browser or an iphone.')
            return true
         }
         return false
      },

      buildCheckSitepresence() {
         return {
            location: this.location,
            userEmail: localStorage.getItem('user_email')
         }
      },

      selectActivityDescription(selection) {
         this.description = selection
      },
      isDescriptionValid() {
         var descriptionPattern = /^[-a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ",.'?!()+=%\/*&\n]+$/g
         var descriptionArray = this.description.split('')
         this.descriptionValid = descriptionArray.length <= 180 && descriptionPattern.test(this.description)
         if (this.selectedActivity) {
            this.descriptionValid = true
         }
      },
      checkActivities(selection) {
         this.checkedActivities = selection
         this.selectActivity(this.activities)
         this.isDescriptionValid()
      },
      selectActivity(selection) {
         if (this.checkedActivities) {
            this.selectedActivity = selection[0]
         }
      },
      getActivities() {
         this.activities = Object.keys(this.$i18n.messages.de.stationDetails.createSitepresenceList.activities).map(
            key => 'stationDetails.createSitepresenceList.activities.' + key
         )
      },
      createDate() {
         let today = new Date()
         if (today.getDate() < 10 && today.getMonth() + 1 < 10) {
            this.todaysDate = '0' + today.getDate() + '.' + '0' + (today.getMonth() + 1) + '.' + today.getFullYear()
         } else {
            this.todaysDate = today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear()
         }
         this.endTime = this.todaysDate
      },
      selectEndTime(selection) {
         this.endTime = selection
      },
      isEndTimeValid() {
         var timePattern = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/
         this.timeValid = timePattern.test(this.endTime)
      },

      getSitepresenceStation() {
         getStation(this.$route.params.code)
            .then(response => {
               this.locationResponse = response
               if (typeof this.locationResponse == 'string') {
                  if (this.locationResponse.includes('Request failed') || this.locationResponse.toLowerCase().includes('error')) {
                     this.error = this.locationResponse
                     console.log(this.error)
                  }
               } else {
                  this.location = this.locationResponse.name
               }
            })
            .catch(e => {
               console.log(e)
            })
      },

      getSitepresenceUserID() {
         getUserID()
            .then(response => {
               this.userResponse = response
               if (typeof this.userResponse == 'string') {
                  if (this.userResponse.includes('Request failed') || this.userResponse.toLowerCase().includes('error')) {
                     this.error = this.userResponse
                     console.log(this.error)
                  }
               } else {
                  this.user = this.userResponse.name
               }
            })
            .catch(e => {
               console.log(e)
            })
      },

      createActivity() {
         // Filters out empty or null Strings and, if both are present, connects them
         this.activity = [this.$i18n.t(this.selectedActivity), this.description].filter(Boolean).join(' - ')
      },

      checkInputs() {

         this.isDescriptionValid()
         this.isEndTimeValid()

         if (this.descriptionValid && this.timeValid) {

            this.endTime = this.endTime
               .split('.')
               .reverse()
               .join('-')
            let date = new Date(this.endTime)
            date.setHours(17)
            this.endDate = date.getTime() / 1000

            this.createActivity()

            if (!this.requestProcessing) {
               this.requestProcessing = true
               this.createSitepresence()
            } else {
               console.log('Error - Problem while creating a Sitepresence!')
            }
         } else {
            console.log('Form is not valid...')
         }
      },

      buildSitepresence() {
         return {
            interventionEndTime: this.endDate,
            location: this.location,
            userID: localStorage.getItem('user_name'),
            userMail: localStorage.getItem('user_email'),
            workDescription: this.activity
         }
      },

      async checkSitepresence() {

         this.loading = true
         try {
            const sitepresence = this.buildCheckSitepresence()

            const queryString = require('querystringify')
            const sitepresenceURL = queryString.stringify(sitepresence, true)

            // Wichtig: importierte API-Funktion heißt ebenfalls "checkSitepresence"
            // -> Rufe sie ohne "this." auf, d.h. checkSitepresence(...)
            let response
            try {
               response = await checkSitepresence(sitepresenceURL)
            } catch (err) {
               console.warn('[checkSitepresence] request failed:', err && err.message)

               // Axios: err.response enthält Status/Body bei non-2xx
               const resp = err && err.response
               if (resp) {
                  console.log('[checkSitepresence] error response status:', resp.status, 'data:', resp.data)
                  if (resp.status === 400) {
                     // Validierungsfehler: wir wollen undefined signalisieren
                     return undefined
                  }
                  // Sonstige Fehler ebenfalls als undefined behandeln (oder spezifisch)
                  return undefined
               }

               // Netzwerkfehler / kein resp
               return undefined
            }

            // Erfolg nur bei 200 akzeptieren
            if (!response || response.status !== 200) {
               console.warn('[checkSitepresence] unexpected status:', response && response.status);
               return undefined
            }

            const data = response.data
            console.log('[checkSitepresence] response.data:', data)

            // Robust boolean parsing (API kann true/false oder {exists: true} liefern)
            let exists = false
            if (data === true || data === 'true' || data === 1 || data === '1') {
               exists = true
            } else if (data && typeof data === 'object') {
               let candidate
               if (data.exists !== undefined) candidate = data.exists
               else if (data.exist !== undefined) candidate = data.exist
               else candidate = data.present
               if (candidate === true || candidate === 'true' || candidate === 1 || candidate === '1') {
                  exists = true
               }
            }
            return exists
         } catch (e) {
            console.error('[checkSitepresence] unexpected exception:', e)
            return undefined
         } finally {
            this.loading = false
            console.log('[checkSitepresence] finished')
         }
      },

      async createSitepresence() {

         this.requestProcessing = true

         try {
            console.log('[createSitepresence] calling this.checkSitepresence()')
            // Lokale Methode aufrufen (this.), die oben implementiert ist
            const exists = await this.checkSitepresence()

            if (exists === true) {
               this.error = 'Ein Sitepresence-Eintrag existiert bereits.'
               console.warn('[createSitepresence] Abbruch: Eintrag existiert bereits.')
               return
            }

            if (exists === undefined) {
               this.error = 'Prüfung auf vorhandene Sitepresence ist fehlgeschlagen. Vorgang abgebrochen.'
               console.warn('[createSitepresence] Abbruch: Prüfung fehlgeschlagen.')
               return
            }

            const sitepresence = this.buildSitepresence();
            console.log('[createSitepresence] payload:', sitepresence)

            const queryString = require('querystringify')
            const sitepresenceURL = queryString.stringify(sitepresence, true)

            // importierte makeSitepresence() ebenfalls ohne this.
            let response
            try {
               response = await makeSitepresence(sitepresenceURL)
            } catch (err) {
               console.error('[createSitepresence] create request failed:', err && err.message)
               const resp = err && err.response
               this.error = resp && resp.data ? resp.data : (err && err.message) || 'Unbekannter Fehler'
               return
            }

            if (response && response.status === 201) {
               console.log('[createSitepresence] created:', response.data)
               this.summary = true
               localStorage.setItem('showCreateSitepresenceMessage', 'true')
               this.showMessage()
            } else {
               this.error = response && response.data ? response.data : 'Unerwartete Antwort beim Erstellen'
               console.error('[createSitepresence] unexpected create response:', response)
            }
         } catch (e) {
            console.error('[createSitepresence] unexpected exception:', e)
            this.error = e && e.message ? e.message : String(e)
         } finally {
            this.requestProcessing = false
            console.log('[createSitepresence] finished')
         }
      },


      showMessage() {
         // Shows a logout message for 4sec
         if (localStorage.showCreateSitepresenceMessage) {
            localStorage.removeItem('showCreateSitepresenceMessage')
            setTimeout(() => {
               this.$refs.notification.show()
            }, 400)
            setTimeout(() => {
               this.$refs.notification.close()
            }, 4000)
         }
      }
   }
}
